import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import { Dispatch, SetStateAction, useCallback } from "react";
import { MutationResponseWithId, SimpleMutationResponse } from "../../sharedTypes";
import { batchedMutation } from "../../batchedMutation";



export const LOCATION_SKIP_FEED_TIMED = gql`
  mutation LocationSkipFeedTime($domain: String!, $locationIds: [Int!]!, $time: Long!) {
    location {
      skipFeedTime(domain: $domain, locationIds: $locationIds, time: $time) {
        code
        message
        success
        id
      }
    }
  }
`

interface SkipFeedTimeResponse {
  location: {
    skipFeedTime: MutationResponseWithId[]
  }
}

interface SkipFeedTimeLocations {
  time: number;
  locationIds: number[]
}


export function useSkipFeedTime() {
  const client = useApolloClient();
  
  const skipFeedTimeLocations = useCallback(
    async ({domain, skipFeedTimeLocations: {time, locationIds}}:{domain: string, skipFeedTimeLocations: SkipFeedTimeLocations}): Promise<SimpleMutationResponse[]> => {
      return await batchedMutation<SkipFeedTimeResponse, {domain: string} & SkipFeedTimeLocations >(
        client,
        {
          mutation: LOCATION_SKIP_FEED_TIMED,
          variables: { domain, locationIds, time },
          responsePath: (data) => data?.location.skipFeedTime,
          ids: locationIds.map(e => e)
        },
      );
    },
    [client]
  );
  
  return {skipFeedTimeLocations}
}